(function () {
  if (window.__osdtgFavorites) return;
  var KEY = 'osdtg:favorites';
  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('osdtg:favorites-change', { detail: list }));
  }
  function toggle(h) {
    var l = read(), i = l.indexOf(h);
    if (i === -1) l.push(h); else l.splice(i, 1);
    write(l);
  }
  function remove(h) { write(read().filter(function (x) { return x !== h; })); }
  function sync() {
    var l = read();
    document.querySelectorAll('[data-osdtg-fav]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-osdtg-fav')) !== -1 ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-osdtg-fav]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    toggle(b.getAttribute('data-osdtg-fav'));
  }, true);
  document.addEventListener('osdtg:favorites-change', sync);
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  try { new MutationObserver(function (m) { if (m.some(function (r) { return r.addedNodes.length; })) sync(); }).observe(document.body || document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  window.__osdtgFavorites = { read: read, toggle: toggle, remove: remove, sync: sync };
})();
